import { Option, none } from '@sapphire/result';
import {
  SurveyQualification,
  SurveySelectableQualification,
} from '../models/survey-qualification.model';
import { Quota } from '../models/survey-quota.model';
import { ADVANCED_TARGETING_QUALIFICATION_CODE_MIN } from '../constants/survey-qualification.constants';

function isSelectableQualification(
  surveyQualification: SurveyQualification,
): surveyQualification is SurveySelectableQualification {
  return !surveyQualification.isRangeType;
}

function isRangeQualification(
  surveyQualification: SurveyQualification,
): boolean {
  return surveyQualification.isRangeType;
}

export class SurveyQualificationInfo {
  constructor(private readonly _surveyQualification: SurveyQualification) {}

  public isSelectable(): boolean {
    return isSelectableQualification(this._surveyQualification);
  }

  public isRange(): boolean {
    return isRangeQualification(this._surveyQualification);
  }

  public conditionCodes(): string[] {
    return isSelectableQualification(this._surveyQualification)
      ? this._surveyQualification.conditionCodes
      : [];
  }

  public rangeValue(): Option<{ min: number; max: number }> {
    if (isSelectableQualification(this._surveyQualification)) {
      return none;
    }

    const [rangeDatum] = this._surveyQualification.data;
    return Option.from(
      rangeDatum ? { min: rangeDatum.min, max: rangeDatum.max } : null,
    );
  }

  public hasQuotas(): boolean {
    return this._surveyQualification.isQuotaSet;
  }

  public isAdvanced(): boolean {
    return (
      this._surveyQualification.qualificationCode >=
      ADVANCED_TARGETING_QUALIFICATION_CODE_MIN
    );
  }

  public hasNestedQuotas(): boolean {
    return false;
  }

  public quotas(): readonly Quota[] {
    return this._surveyQualification.quotas;
  }
}
